export const BASE_URL = 'collections';
export const MEDIA_BASE_URL = 'media';

export const ANALYTICS_NAME = {
  KEYBOARD_NEXT: 'collections modal - next navigation from keyboard',
  KEYBOARD_PREVIOUS: 'collections modal - next navigation from keyboard',
  MODAL_OPENED: 'collections modal - opened',
  MODAL_FIRM_CLICKED: 'collections modal - firm clicked',
  MODAL_VIEW_ALL_FIRM_IMAGES: 'collections modal - view all firm images',
  MODAL_PROJECT_CLICKED: 'collections modal - project clicked',
  MODAL_ALL_PROJECT_TYPE: 'collections modal - view all project type',
  MODAL_VIEW_ALL_LOCATION: 'collections modal - view all location',
  MODAL_CONTACT_PROJECT_CLICKED: 'collections modal - project clicked',
  MODAL_CONTACT_FIRM_CLICKED: 'collections modal - contact firm',
  MODAL_VIEW_ALL_SEARCH_TERM: 'collections modal - view all search term',
  CORNER_BUTTON_NEXT: 'collections modal - next navigation',
  CORNER_BUTTON_PREVIOUS: 'collections modal - previous navigation',
  SHARE_LINK: 'collections modal - share Copy Link',
  SHARE_PINTEREST: 'collections modal - share Pinterest',
  SHARE_WHATSAPP: 'collections modal - share Whatsapp',
  SHARE_FACEBOOK: 'collections modal - share Facebook',
  SHARE_TWITTER: 'collections modal - share Twitter',
  SHARE_EMAIL: 'collections modal - share Email',
  ON_IMAGE_NEXT: 'collections modal - next navigation on image',
  ON_IMAGE_PREVIOUS: 'collections modal - previous navigation on image',
};
